module.exports = __webpack_public_path__ + "assets/img/dark-personal-portfolio-landing.72da54b5.png";